export default {
  whalersClub: {
    progressBar: {
      // eslint-disable-next-line no-template-curly-in-string
      thresholdLabel: '${{amount}}+',
      percentBack: '{{percent}}% back',
      amountBack: '{{amount}} back',
      amountPlayed: '{{amount}} played',
      callToActionLine1: 'Play QuickPicks and get',
      callToActionLine2: 'credits back.',
      callToActionLine2LossBack: 'credits back on losses.',
      percent: '{{percent}}%',
      percentOnLosses: '{{percent}}% on losses',
    },
    faqAccordion: {
      howItWorks: 'How it works',
      schedule: 'Schedule',
      whalersClubTiers: 'Whalers club tiers',
      whatCounts: 'What qualifies',
      whatDoesNotCount: "What doesn't qualify",
      weeklyEntryFees: 'Weekly entry fees: {{range}}',
      splashCreditsRange: 'Splash Credits Range: {{range}}',
      tierRewardLabel: '{{percent}}% Reward',
      tierRewardLabelLossBack: '{{percent}}% on losses',
      yourRewardsHistory: 'Your rewards history',
    },
    detailModal: {
      deadline: 'by {{deadline}}',
      deadlineLossBack: 'by {{deadline}} ET',
      progressToTier: '{{amount}} to reach {{tierName}}',
      currentPlaythrough: '{{amount}} played through',
    },
    promoCard: {
      titleBase: 'Get $ back on all entries',
      titleTierNotAchieved: '{{amount}} to reach {{tierName}}',
      titleTierAchieved: "You're getting {{percent}}% back!",
      subtitleBase: 'with Whalers Club',
      subtitleTierAchieved: 'with Whalers Club by {{day}}',
      tooltipReward: '{{percent}}% back',
      titleBaseLossBack: 'Get $ back on losses',
      titleTierAchievedLossBack: "You've reached {{tierName}}!",
      subtitleTierAchievedLossBack: '{{percent}}% back on losses through {{day}}',
      tooltipRewardLossBack: '{{percent}}% on losses',
      rewardPercent: '{{percent}}%',
      moreButton: 'More',
      dismissButton: 'Dismiss',
    },
    rewardHistory: {
      title: 'Whalers Club Reward History',
      selectLabel: 'Select period',
      totalEntries: 'Total QuickPicks entries:',
      duration: 'Week duration',
      status: 'Status:',
      rewardId: 'ID: {{rewardId}}',
      note: 'Transaction history shows only weeks in which you reached Whalers Club (WC).',
      empty: 'No reward history found for this period.',
    },
  },
};
